export const NEW_USER = "new-user"
export const PROMO_PACKAGE = "promo-package"
export const PROMO_PACKAGE_500 = "promo-package-500"
export const PROMO_PACKAGE_1000 = "promo-package-1000"
export const PROMO_PACKAGE_3000 = "promo-package-3000"
export const PROMO_PACKAGE_5000 = "promo-package-5000"
export const VOUCHER_SETTING_LIST = {
    [NEW_USER]: {
        key: NEW_USER,
        label: "New User Voucher Setting",
    },
    [PROMO_PACKAGE]: {
        key: PROMO_PACKAGE,
        label: "Promo Package Voucher Setting",
    },
    [PROMO_PACKAGE_500]: {
        key: PROMO_PACKAGE_500,
        label: "Promo Package 500 Voucher Setting",
    },
    [PROMO_PACKAGE_1000]: {
        key: PROMO_PACKAGE_1000,
        label: "Promo Package 1000 Voucher Setting",
    },
    [PROMO_PACKAGE_3000]: {
        key: PROMO_PACKAGE_3000,
        label: "Promo Package 3000 Voucher Setting",
    },
    [PROMO_PACKAGE_5000]: {
        key: PROMO_PACKAGE_5000,
        label: "Promo Package 5000 Voucher Setting",
    },
};